import { Erp1cObjectTypeEnum } from '@zaoblako/shared/modules/catalog/enums/erp-1c-object-type.enum';
import { Erp1cObjectTypeEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/erp-1c-object-type-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { DocumentCheckersEnum } from '@zaoblako/shared/modules/document/enums/document-checkers.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { IntegrationCheckersEnum } from '@zaoblako/shared/modules/integration/enums/integration-checkers.enum';
import type { Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import type { OperationTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-find.dto';

/** 1C ERP native operation type create and update APIs request body - DTO signature */
export interface Erp1cOperationTypeFormInterface {
  /** Operation type name in 1C ERP database */
  name: string;
  /** Operation type alias in 1C ERP database */
  alias: string;
  /** Related object type in 1C ERP database */
  objectType: Erp1cObjectTypeEnum;
  /** FRM operation type this 1C ERP operation type belongs to */
  operationType: OperationTypeFindInterface;
  /** 1C ERP database this operation type belongs to */
  connection: Connection1cFindInterface;
}

/** 1C ERP native operation type create and update APIs request body - DTO schema */
export const Erp1cOperationTypeFormDto = SerdeDtoClass.create<Erp1cOperationTypeFormInterface>(CatalogDtosKeysEnum.ERP_1C_OPERATION_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  alias: {
    label: 'Синоним',
    serializer: nonEmptyStringSchema,
  },
  objectType: {
    label: 'Тип объекта в 1С',
    serializer: commonEnumValidator(Erp1cObjectTypeEnum, Erp1cObjectTypeEnumI18n)
  },
  operationType: {
    label: 'Вид операции ФРМ',
    serializer: entityLikeSchemaStrict,
    checkers: [DocumentCheckersEnum.OPERATION_TYPE_ASSERT_EXISTS_BY_DTO],
  },
  connection: {
    label: 'База 1С',
    serializer: entityLikeSchemaStrict,
    checkers: [IntegrationCheckersEnum.CONNECTION_1C_ASSERT_EXISTS_BY_DTO],
  },
});
